/* eslint-disable */
import React, { useState, useEffect, Fragment } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import Page from '../../../../Page';
import { LoadingButton } from '@material-ui/lab';
import {
    Card,
    Grid,
    TextField,
    Container,
    Tooltip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Stack,
    ButtonGroup
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';
import MenuItem from '@material-ui/core/MenuItem';

var screenCode = "FARMER"

export function Family({ handleNext, handleBack, farmerId }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerFamilyID, setFarmerFamilyID] = useState();
    const [familyArray, setFamilyArray] = useState([]);
    const [groupFactory, setGroupFactory] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Supplier Family details"
    });
    const today = new Date().toISOString().split('T')[0];
    const [educationTypeID, seteducationTypeID] = useState();
    const [occupationID, setoccupationID] = useState();
    const [allDisableButton, setAllDisableButton] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        age: '',
        relationshipTypeID: '',
        //  education: '',
        dob: null,
        educationTypeID: 0,
        eduother: '',
        occupationID: '',
        ocuother: '',
        gender: 0
    });
    const [deleteIndex, setDeleteIndex] = useState()

    useEffect(() => {
        trackPromise(
            GetFarmerFamilyByFarmerID());
        GetModeofOperationbyFarmerID(farmerId);
    }, []);

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setGroupFactory({
            ...groupFactory,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function GetModeofOperationbyFarmerID(farmerId) {
        const res = await services.GetModeofOperationbyFarmerID(farmerId)
        if (res == 1) {
            setAllDisableButton(true)
        }
        else {
            setAllDisableButton(false)
        }
    }

    const familySaveSchema = Yup.object().shape({
        name: Yup.string().required('Name required').matches(/^[aA-zZ\s\.]+$/, "Only alphabets are allowed for this field")
            .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
                if (value && value.startsWith(' ')) {
                    return false;
                }
                return true;
            }),
        age: Yup.string().matches(/^[0-9\b]+$/, 'Only allow numbers').nullable(),
        educationTypeID: Yup.number().nullable(true),
        eduother: educationTypeID == 10 ? Yup.string().required('Other Higher Level Education required') : Yup.string().nullable(true),
        ocuother: occupationID == 7 ? Yup.string().required('Name of Other Occupation required') : Yup.string().nullable(true),
    });

    const formik = useFormik({
        initialValues: {
            name: formData.name,
            age: formData.age,
            relationshipTypeID: formData.relationshipTypeID,
            // education: formData.education,
            dob: formData.dob,
            educationTypeID: formData.educationTypeID,
            eduother: formData.eduother,
            occupationID: formData.occupationID,
            ocuother: formData.ocuother,
            gender: formData.gender
        },

        validationSchema: familySaveSchema,
        onSubmit: (values) => {
            addGrid(values);
        },
        enableReinitialize: true
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        seteducationTypeID(formik.values.educationTypeID);
    }, [formik.values.educationTypeID]);

    useEffect(() => {
        setoccupationID(formik.values.occupationID);
    }, [formik.values.occupationID]);

    async function addGrid(values) {
        const exists = familyArray.find(x => x.name === values.name);
        if (exists) {
            toast.error("Name already Exists.");
        }
        else {
            if (pageProps.Edit != true) {
                let sampleFamily = {
                    farmerID: parseInt(farmerId),
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    name: values.name,
                    age: values.age == "" ? 0 : parseInt(values.age),
                    //relationshipTypeID: parseInt(values.relationshipTypeID),
                    //education: values.education.trim(),
                    //occupationID: parseInt(values.occupationID),
                    dob: values.dob == null || values.dob == "" ? null : values.dob,
                    educationTypeID: values.educationTypeID == 0 ? null : parseInt(values.educationTypeID),
                    eduother: values.educationTypeID != 10 ? "" : values.eduother.trim(),
                    ocuother: values.ocuother.trim(),
                    gender: parseInt(values.gender)
                };
                const res = await services.SaveFarmerFamilyDetail(sampleFamily);
                if (res.statusCode == 'Success') {
                    toast.success("Family Details Saved Succesfully");
                    trackPromise(GetFarmerFamilyByFarmerID(farmerId));
                    clearAll();
                } else {
                    toast.error("Error occured in Farmer Family Details.");
                }
            }
            else {
                let updateFamily = {
                    farmerFamilyDetailID: parseInt(pageProps.editingID),
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    name: values.name,
                    age: values.age == "" ? 0 : parseInt(values.age),
                    //relationshipTypeID: values.relationshipTypeID,
                    //occupationID: values.occupationID,
                    //dob: values.dob.trim(),
                    dob: values.dob == null || values.dob == "" ? null : values.dob,
                    educationTypeID: values.educationTypeID == 0 ? null : values.educationTypeID,
                    eduother: values.eduother == null ? null : values.educationTypeID != 10 ? "" : values.eduother.trim(),
                    ocuother: values.ocuother == null ? null : values.ocuother.trim(),
                    gender: parseInt(values.gender)
                };
                const res = await services.UpdateFarmerFamilyDetail(updateFamily);
                if (res.statusCode == 'Success') {
                    toast.success("Family Details Updated Succesfully");
                    trackPromise(GetFarmerFamilyByFarmerID(farmerId));
                    setPageProps({
                        ...pageProps,
                        editingID: 0,
                        Edit: false,
                        submitButtonName: "Add",
                    })
                    clearAll();
                } else {
                    toast.error("Error occured in Farmer Family Details.");
                }
            }
        }
    }

    async function GetFarmerFamilyByFarmerID() {
        var res = await services.GetFarmerFamilyByFarmerID(farmerId);
        if (res.statusCode === "Success") {
            setFamilyArray(res.data);
        }
    }



    async function DeleteItem(detleteData, index) {
        if (familyArray[index].farmerFamilyDetailID !== undefined) {
            const response = await services.CheckIfScholarshipExists(familyArray[index].farmerFamilyDetailID);
            if (response.data === 1) {
                toast.error('Remove the member\'s scholarship first.');
            }
            else {
                const res = await services.DeleteFarmerFamilyDetil(familyArray[index].farmerFamilyDetailID);
                var result = familyArray.filter((img, i) => i !== index);
                setFamilyArray(result);

                if (res.data === 1) {
                    toast.success('Deleted successfully');
                } else {
                    toast.error('Error occured when deleting');
                }
            }
        }

        else {
            var result = familyArray.filter((x, i) => i !== index);
            setFamilyArray(result);
            toast.success('Deleted successfully');
        }

    }

    async function clearAll() {
        formik.resetForm();
        setValues({
            ...values,
            name: '',
            age: '',
            relationshipTypeID: '',
            dob: '',
            educationTypeID: '',
            eduother: '',
            occupationID: '',
            ocuother: '',
            gender: 0
        })
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerFamilyID, deleteIndex);
        }
    }

    function handleConfirm(data, index) {
        setDeleteIndex(index)
        setFarmerFamilyID(data);
        setEnableConfirmMessage(true);
    }

    function handleEdit(rowData, index) {
        var array = [...familyArray];
        setValues({
            ...values,
            name: rowData.name,
            age: rowData.age == 0 ? '' : rowData.age,
            relationshipTypeID: rowData.relationshipTypeID,
            // education: rowData.education,
            occupationID: rowData.occupationID,
            // dob: rowData.dob,
            dob: rowData.dob == null ? null : new Date(rowData.dob).toISOString().split('T')[0],
            educationTypeID: rowData.educationTypeID,
            eduother: rowData.eduother == null ? "" : rowData.eduother,
            ocuother: rowData.ocuother,
            gender: rowData.gender
        })
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            editingID: rowData.farmerFamilyDetailID,
            Edit: true,
            submitButtonName: "Update",
        })
        setFamilyArray(array);

    }

    return (
        <>
            <LoadingComponent />
            <Page title="Family Details  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">{(factoryType == 1 || factoryType == 3) ? "View Family Details" : "Family Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Personal Details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Sarubima">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <div>
                                        <h4>
                                            Please provide only the children's information for the family details.
                                        </h4>
                                    </div>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Name *"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('name')}
                                            error={Boolean(touched.name && errors.name)}
                                            helperText={touched.name && errors.name}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        />
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Gender "
                                            value={formik.values.gender}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('gender')}
                                            error={Boolean(touched.gender && errors.gender)}
                                            helperText={touched.gender && errors.gender}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            InputProps={{
                                                readOnly: pageProps.isEditType == 3
                                            }}
                                        >
                                            <MenuItem key={0} value={0}> Select Gender</MenuItem>
                                            <MenuItem value={1}> Male</MenuItem>
                                            <MenuItem value={2}> Female</MenuItem>
                                            <MenuItem value={3}> Other</MenuItem>
                                            <MenuItem value={4}> Prefer not to mention</MenuItem>
                                        </TextField>
                                        <TextField
                                            fullWidth
                                            id="outlined-name"
                                            size="small"
                                            type="date"
                                            label="Date of Birth"
                                            value={formik.values.dob}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('dob')}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: new Date().toISOString().split('T')[0],
                                            }}
                                            error={Boolean(touched.dob && errors.dob)}
                                            helperText={touched.dob && errors.dob}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        />
                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Highest Level of Education"
                                            value={formik.values.educationTypeID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('educationTypeID')}
                                            error={Boolean(touched.educationTypeID && errors.educationTypeID)}
                                            helperText={touched.educationTypeID && errors.educationTypeID}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            <MenuItem key={0} value={0}> Select Highest Level of Education</MenuItem>
                                            <MenuItem value={1}> No Formal Education</MenuItem>
                                            <MenuItem value={2}> Grade 1 to 5</MenuItem>
                                            <MenuItem value={3}> Upto Grade 8</MenuItem>
                                            <MenuItem value={4}> O/Ls</MenuItem>
                                            <MenuItem value={5}> A/Ls</MenuItem>
                                            <MenuItem value={6}> Diploma</MenuItem>
                                            <MenuItem value={7}> Graduate</MenuItem>
                                            <MenuItem value={8}> Postgraduate</MenuItem>
                                            <MenuItem value={9}> Doctorate</MenuItem>
                                            <MenuItem value={10}> Other</MenuItem>
                                        </TextField>
                                        {/* <TextField
                                            fullWidth
                                            size="small"
                                            label="Age "
                                            value={formik.values.age}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('age')}
                                            error={Boolean(touched.age && errors.age)}
                                            helperText={touched.age && errors.age}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        /> */}
                                    </Stack>
                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Stack width={340}>
                                            {formik.values.educationTypeID == 10 ? (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Other Education Type *"
                                                    value={formik.values.eduother}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('eduother')}
                                                    error={Boolean(touched.eduother && errors.eduother)}
                                                    helperText={touched.eduother && errors.eduother}
                                                    disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                                />
                                            ) : null}
                                        </Stack>
                                        {/* <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Relationship Type "
                                                value={formik.values.relationshipTypeID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('relationshipTypeID')}
                                                error={Boolean(touched.relationshipTypeID && errors.relationshipTypeID)}
                                                helperText={touched.relationshipTypeID && errors.relationshipTypeID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Relationship Type</MenuItem>
                                                <MenuItem value={1}> Spouse</MenuItem>
                                                <MenuItem value={2}> Child</MenuItem>
                                                <MenuItem value={3}> Sibling</MenuItem>
                                                <MenuItem value={4}> Parent</MenuItem>
                                            </TextField>
                                        </Stack> */}
                                    </Stack>
                                    <br />
                                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Occupation "
                                                value={formik.values.occupationID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('occupationID')}
                                                error={Boolean(touched.occupationID && errors.occupationID)}
                                                helperText={touched.occupationID && errors.occupationID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Occupation </MenuItem>
                                                <MenuItem value={1}> Agri</MenuItem>
                                                <MenuItem value={2}> Dairy</MenuItem>
                                                <MenuItem value={3}> Private Sector Employment</MenuItem>
                                                <MenuItem value={4}> Public Sector Employment</MenuItem>
                                                <MenuItem value={5}> Business</MenuItem>
                                                <MenuItem value={6}> Not Applicable</MenuItem>
                                                <MenuItem value={7}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>
                                            {formik.values.occupationID == 7 ? (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Other Occupation *"
                                                    value={formik.values.ocuother}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('ocuother')}
                                                    error={Boolean(touched.ocuother && errors.ocuother)}
                                                    helperText={touched.ocuother && errors.ocuother}
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                />
                                            ) : null}
                                        </Stack>
                                    </Stack> */}
                                    <br />
                                    <Divider />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                    <Card>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            {(familyArray.length > 0) ?
                                                <Grid item xs={12}>
                                                    <TableContainer >
                                                        <Table style={{ minWidth: 850 }} aria-label="caption table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center">Name</TableCell>
                                                                    <TableCell align="center">Gender</TableCell>
                                                                    <TableCell align="center">Date of Birth</TableCell>
                                                                    <TableCell align="center">Highest Level of Education</TableCell>
                                                                    {/* <TableCell align="center">Occupation</TableCell> */}
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center">Action</TableCell>}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {familyArray.map((rowData, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.name}
                                                                        </TableCell>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.gender == 1
                                                                                ? 'Male'
                                                                                : rowData.gender == 2
                                                                                    ? 'Female'
                                                                                    : rowData.gender == 3
                                                                                        ? 'Other' : "Prefer not to mention"}
                                                                        </TableCell>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.dob == null ? '' : rowData.dob.split("T")[0]}
                                                                        </TableCell>

                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.educationTypeID == 1
                                                                                ? 'No Formal Education'
                                                                                : rowData.educationTypeID == 2
                                                                                    ? 'Grade 1 to 5'
                                                                                    : rowData.educationTypeID == 3
                                                                                        ? 'Upto Grade 8'
                                                                                        : rowData.educationTypeID == 4
                                                                                            ? 'O/Ls'
                                                                                            : rowData.educationTypeID == 5
                                                                                                ? 'A/Ls'
                                                                                                : rowData.educationTypeID == 6
                                                                                                    ? 'Diploma'
                                                                                                    : rowData.educationTypeID == 7
                                                                                                        ? 'Undergraduate'
                                                                                                        : rowData.educationTypeID == 8
                                                                                                            ? 'Postgraduate'
                                                                                                            : rowData.educationTypeID == 9
                                                                                                                ? 'Doctorate'
                                                                                                                : rowData.eduother
                                                                            }
                                                                        </TableCell>
                                                                        {/* <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.occupationID == 1
                                                                                ? 'Agri'
                                                                                : rowData.occupationID == 2
                                                                                    ? 'Dairy'
                                                                                    : rowData.occupationID == 3
                                                                                        ? 'Private Sector Employment'
                                                                                        : rowData.occupationID == 4
                                                                                            ? 'Public Sector Employment'
                                                                                            : rowData.occupationID == 5
                                                                                                ? 'Business'
                                                                                                : rowData.occupationID == 6
                                                                                                    ? 'Not Applicable'
                                                                                                    : rowData.ocuother
                                                                            }
                                                                        </TableCell> */}
                                                                        {(factoryType == 1 || factoryType == 3) ? null :
                                                                            <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                                {pageProps.Edit != true ?
                                                                                    <Tooltip title="Edit">
                                                                                        <IconButton
                                                                                            variant="outlined"
                                                                                            onClick={() => handleEdit(rowData, index)}>
                                                                                            <EditIcon />
                                                                                        </IconButton>
                                                                                    </Tooltip> : null}
                                                                                <Tooltip title="Delete">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        color="error"
                                                                                        onClick={() => handleConfirm(rowData, index)}>
                                                                                        <DeleteIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </TableCell>}
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                                : null}
                                        </Stack>
                                    </Card>
                                </Stack>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure you want to delete family details? Please check if a Sarubima is added for the particular member."} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page >
        </>
    )
}